import { render, staticRenderFns } from "./ActionQuicklinks.vue?vue&type=template&id=7524ab68&scoped=true&"
import script from "./ActionQuicklinks.vue?vue&type=script&lang=js&"
export * from "./ActionQuicklinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524ab68",
  null
  
)

export default component.exports